var map = {
	"./de.json": [
		8657,
		987
	],
	"./en.json": [
		4370,
		627
	],
	"./es.json": [
		6953,
		309
	],
	"./fr.json": [
		1563
	],
	"./it.json": [
		7025,
		468
	],
	"./pt.json": [
		2808,
		759
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(function() {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return Promise.all(ids.slice(1).map(__webpack_require__.e)).then(function() {
		return __webpack_require__(id);
	});
}
webpackAsyncContext.keys = function() { return Object.keys(map); };
webpackAsyncContext.id = 5249;
module.exports = webpackAsyncContext;